import React, { FC } from "react";
import { AddIcon } from "@/components/assets/icons";
import classNames from "classnames";
import { useTheme } from "@/context/Theme.context";
import { Theme } from "@/enums";

type Props = {
  onClick: () => void;
  containerClassName?: string;
  iconClassName?: string;
};

const AddButton: FC<Props> = ({
  onClick,
  containerClassName,
  iconClassName,
}) => {
  const theme = useTheme();

  const backgroundColor =
    theme === Theme.GEORGIA || theme === Theme.UZ
      ? "bg-[#e7fafd]"
      : "bg-[#FFE5D2]";

  const iconColor =
    theme === Theme.GEORGIA || theme === Theme.UZ
      ? "fill-[#018b9e]"
      : "fill-[#eb7623]";

  return (
    <div
      className={classNames(
        `mb-0 flex h-[62px] w-[62px] cursor-pointer items-center justify-center rounded-full p-6 ${backgroundColor}`,
        containerClassName,
      )}
      onClick={onClick}
    >
      <AddIcon
        className={classNames(`${iconColor} h-[13px] w-[13px]`, iconClassName)}
      />
    </div>
  );
};

export default AddButton;
